module.exports = __webpack_public_path__ + "static/media/DSC04138.17dde546.jpg";